import BaseAPI from './base';

// GET /api/web/v1/student/demarches/cases(/:id) — the signed-in student's own cases. Requires the
// Devise session `submit` already establishes (backend-plan.md §7.2). `list` is also used to look
// up the partner name for the confirmation screen (best-effort, see DemarcheFunnelStore#fetchHandledBy).
class DemarcheCasesAPI extends BaseAPI {
  list() {
    return this.get('/api/web/v1/student/demarches/cases', {});
  }

  show(id: string) {
    return this.get(`/api/web/v1/student/demarches/cases/${id}`, {});
  }
}

export default new DemarcheCasesAPI();
